import {handleActions} from 'redux-actions';

import {
  GET_TESTING_OPTIONS,
  UPDATE_DATE,
  UPDATE_LAST_PERIOD_ID,
  UPDATE_LATEST_ACCEPTED_PERIOD_ID,
  UPDATE_OPEN_PERIOD_ID,
  UPDATE_PERIOD_ID,
} from '/redux/action/testingOptions.action';
import {withPayload} from '/util/reducer.util';

import updateDate from './testingOptions/updateDate';
import updateLastPeriodId from './testingOptions/updateLastPeriodId';
import updateLatestAcceptedPeriodId from './testingOptions/updateLatestAcceptedPeriodId';
import updateOpenPeriodId from './testingOptions/updateOpenPeriodId';
import updateOptions from './testingOptions/updateOptions';
import updatePeriodId from './testingOptions/updatePeriodId';

const initialState = {
  date: null,
  lastPeriodId: null,
  latestAcceptedPeriodId: null,
  openPeriodId: null,
  currentPeriodId: null,
};

export default handleActions(
  {
    [GET_TESTING_OPTIONS]: withPayload(updateOptions),
    [UPDATE_PERIOD_ID]: withPayload(updatePeriodId),
    [UPDATE_DATE]: withPayload(updateDate),
    [UPDATE_LAST_PERIOD_ID]: withPayload(updateLastPeriodId),
    [UPDATE_LATEST_ACCEPTED_PERIOD_ID]: withPayload(
      updateLatestAcceptedPeriodId,
    ),
    [UPDATE_OPEN_PERIOD_ID]: withPayload(updateOpenPeriodId),
  },
  initialState,
);
